import {
  baseCdcEventDataSchema,
  cdcAuthContextSchema,
  cdcEventModule,
  cdcEventType,
} from '@tempo-io/common-dto';
import { discriminatedUnion, z } from 'zod';

export const workIntegrationBaseCdcEventSchema = baseCdcEventDataSchema.extend({
  module: z.literal(cdcEventModule.enum['work-integration']),
});

export const workIntegrationStatus = z.enum([
  'CREATED',
  'QUEUED',
  'RUNNING',
  'COMPLETED',
  'COMPLETED_WITH_PENDING',
  'PARTIAL_FAILURE',
  'FAILED',
]);

export const synchronizationStatusSchema = z.enum(['ENABLED', 'DISABLED', 'DELETING']);

export const sourceSystemTypeSchema = z.enum(['JIRA', 'ADO']);

export const workIntegrationIdentifierSchema = z.object({
  id: z.number().int(),
});

export const workIntegrationEntitySchema = z
  .object({
    id: z.number().int(),
    synchronizationStatus: synchronizationStatusSchema.optional(),
    status: workIntegrationStatus,
    sourceSystemType: sourceSystemTypeSchema.optional(),
    lastPullSyncAt: z.string().nullish(),
    lastPushSyncAt: z.string().nullish(),
    lastPulledBy: z.string().nullish(),
    lastPushedBy: z.string().nullish(),
    excludedTeamCount: z.number().int().optional(),
    excludedTeams: z.array(z.object({ teamName: z.string(), loopName: z.string() })).optional(),
  })
  .loose();

export const workIntegrationDataChangeDTOSchema = discriminatedUnion('eventType', [
  workIntegrationBaseCdcEventSchema.extend({
    entityType: z.literal('work-integration'),
    eventType: z.literal(cdcEventType.enum.created),
    entity: workIntegrationEntitySchema,
  }),
  workIntegrationBaseCdcEventSchema.extend({
    entityType: z.literal('work-integration'),
    eventType: z.literal(cdcEventType.enum.updated_full),
    entity: workIntegrationEntitySchema,
  }),
  workIntegrationBaseCdcEventSchema.extend({
    entityType: z.literal('work-integration'),
    eventType: z.literal(cdcEventType.enum.deleted),
    entity: workIntegrationIdentifierSchema,
  }),
]);

export const workIntegrationServiceDataChangeDTOSchema = z.object({
  data: workIntegrationDataChangeDTOSchema,
  authContext: cdcAuthContextSchema,
  metadata: z.record(z.string(), z.string()).optional(),
});

export type WorkIntegrationServiceDataChangeDTO = z.output<
  typeof workIntegrationServiceDataChangeDTOSchema
>;
export type WorkIntegrationDataChangeDTO = WorkIntegrationServiceDataChangeDTO['data'];
